import { 
    IonImg,
} from '@ionic/react';
import './Footer.css'
/**
 * Generates the footer of the landing page
 * @returns footer component
 */
const Footer = () => {
  return(
      <div className="prelogin-footer-background">
          <div className="prelogin-footer-content">
              <div className="prelogin-footer-logo-container">
                  <a href="https://rydesharing.com">
                      <IonImg className="prelogin-footer-logo" src='logo/rydelogowhite.svg'/>
                  </a>
              </div>
              <div className="prelogin-footer-text-container font-opensans font-regular font-white">
                  © 2022 Ryde Technologies Pte. Ltd. All Rights Reserved. GST No: 201425891W
                  <br />
                  <a className = "prelogin-footer-text font-white" href="https://www.rydesharing.com/terms-of-use/" target="_blank" title="Terms of use">Terms of use </a>
                  |
                  <a className = "prelogin-footer-text font-white" href="https://www.rydesharing.com/privacy-policy/" target="_blank" title="Privacy Policy"> Privacy Policy </a>
                  |
                  <a className = "prelogin-footer-text font-white" href="https://www.rydesharing.com/code-of-conduct/" target="_blank" title="Code of conduct"> Code of conduct </a>
                  |
                  <a className = "prelogin-footer-text font-white" href="https://help.rydesharing.com/hc/en-us" target="_blank" title="FAQ"> FAQ</a>
              </div>
              <div className="prelogin-footer-social-container">
                  <div className='prelogin-footer-social-icon'>
                      <div className="prelogin-footer-social-icon-list">
                          <li>
                              <a className="prelogin-footer-social-facebook" href="https://www.facebook.com/rydesg/" target="_blank">
                                  <IonImg className="prelogin-footer-social-facebook-logo" src='social/facebook.png'/>
                              </a>
                          </li>
                          <li>
                              <a className="prelogin-footer-social-facebook" href="https://www.instagram.com/ryde_sg/" target="_blank">
                              <IonImg className="prelogin-footer-social-instagram-logo" src='social/instagram.png'/>
                              </a>
                          </li>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  )
}
export default Footer;